(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneTypeSearch', PhoneTypeSearch);

    PhoneTypeSearch.$inject = ['$resource'];

    function PhoneTypeSearch($resource) {
        var resourceUrl =  'api/_search/phone-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
